<template>
  <el-card shadow="never"
    ><el-page-header @back="goBack" :content="componentName"> </el-page-header>
    <el-divider></el-divider>
    <!-- 表单 -->
    <el-form ref="formNewCourse" :model="formNewCourse" label-width="80px">
      <!-- 课程名称 -->
      <el-form-item label="课程名称">
        <el-input
          style="width: 20%"
          size="mini"
          v-model="formNewCourse.course_name"
        ></el-input>
      </el-form-item>
      <!-- 课程作者 -->
      <el-form-item label="作者">
        <el-input
          style="width: 20%"
          size="mini"
          v-model="formNewCourse.author"
        ></el-input>
      </el-form-item>
      <!-- 封面 -->
      <el-form-item label="课程封面">
        <up-load @getImageURl="getImageURl"></up-load>
      </el-form-item>
      <!-- 简介 -->
      <el-form-item label="课程简介">
        <el-input
          style="width: 40%"
          type="textarea"
          v-model="formNewCourse.course_info"
        ></el-input>
      </el-form-item>
      <!-- 售价 -->
      <el-form-item label="售价">
        <el-input
          style="width: 20%"
          size="mini"
          v-model="formNewCourse.sell_price"
        ></el-input>
      </el-form-item>
      <!-- 划线价 -->
      <el-form-item label="划线价">
        <el-input
          style="width: 20%"
          size="mini"
          v-model="formNewCourse.underlined_price"
        ></el-input>
      </el-form-item>
      <!-- 会员专享 -->
      <el-form-item label="会员专享">
        <el-switch v-model="formNewCourse.member_discount"></el-switch>
      </el-form-item>

      <!-- 提交表单 -->
      <el-form-item>
        <el-button size="mini" type="primary" @click="onSubmitNewCourse"
          >立即创建</el-button
        >
        <el-button size="mini">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import UpLoad from "../../components/common/other/UpLoad";
import { tpx_app } from "../../network/request";

export default {
  name: "creat-new-course",
  components: {
    "up-load": UpLoad,
  },
  data() {
    return {
      componentName: "",
      formNewCourse: {},
    };
  },
  mounted() {
    this.componentName = this.$route.params.componentName;
    // 加载组件的页头名称，更新课程 或  新建课程等
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    // 上传图片后获得链接
    getImageURl(value) {
      this.formNewCourse.course_cover = value;
    },
    // 提交课程
    onSubmitNewCourse() {
      tpx_app({
        url: "/creat_new_course",
        method: "POST",
        data: this.formNewCourse,
      }).then((res) => {
        // console.log(res);
        const { errno, errmsg } = res.data;
        if (errno == "0") {
          this.$notify({
            title: "成功",
            message: errmsg,
            type: "success",
          });
        } else {
          this.$$notify.error({
            title: "错误",
            message: errmsg,
          });
        }
      });
    },
  },
};
</script>

<style>
</style>